import React from 'react'
import './HoverExtraInformation.scss'
import classNames from 'classnames'

interface HoverExtraInformationProps {
  label: string
  children?: React.ReactNode
  collapsible?: boolean
  title?: React.ReactChild
  showDescription?: boolean
  outline?: boolean
  inlineLabel?: boolean
}

const HoverExtraInformation: React.FC<HoverExtraInformationProps> = (props) => {
  const { inlineLabel, outline, label, children, collapsible, title, showDescription: showDescriptionImmediately } = props
  const [showDescription, setShowDescription] = React.useState(showDescriptionImmediately || false)

  const labelNode = (
    <div className={classNames('HoverLabel', { 'Visible': showDescription, 'Keyline':outline })}>
      {children}
    </div>
  )

  return (
    <div className={classNames('HoverExtraInformation', { collapsible })}>
      <div
        className="TitleRow"
        onClick={() => {
          if (collapsible) {
            setShowDescription(value => !value)
          }
        }}
      >
        {title && <span className="Title">{title}</span>}
        <span className={classNames('HoverButton', { 'Keyline': outline })}>
          {label}
        </span>
        {inlineLabel && labelNode}
      </div>
      {!inlineLabel && labelNode}
    </div>
  )
}

export default HoverExtraInformation